'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _adminUserAddForm = require('./admin-user-add-form.html');

var _adminUserAddForm2 = _interopRequireDefault(_adminUserAddForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _adminUserAddForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    onUserChanged: '&'
  },
  controller: function () {
    function AdminUserAddFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, AdminUserAddFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(AdminUserAddFormComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.user = this.user || {};
        this.user.UserTypeId = 4;
        this.user.TypeReferenceId = -1;
        this.user.LevelOfAccess = 4;
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        this.onUserChanged(this.EventEmitter({
          user: this.user
        }));
      }
    }]);

    return AdminUserAddFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-add-form/admin-user-add-form.component.js